import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

function cleanUrl(url: string): string {
  return url.replace(/^https?:\/\//, "").replace(/^www\./, "");
}

function WebFetchHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const input = toolUse.input as { url?: string } | undefined;
  const url = input?.url;
  const done = !!result && !result.isError;
  if (!done) {
    return <ToolStatus icon="earth" text="Fetching…" pending={!interrupted} />;
  }
  return (
    <ToolStatus icon="earth" text={`Fetched ${url ? cleanUrl(url) : ""}`} />
  );
}

function WebFetchBody({ toolUse, result }: ToolUseProps) {
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(toolUse.input, null, 2)}
      </pre>
      {result && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {JSON.stringify(result.output, null, 2)}
        </pre>
      )}
    </Text>
  );
}

export const webFetch: ChatTool = {
  name: "webFetch",
  Header: WebFetchHeader,
  Body: WebFetchBody,
};
